import VideoJS from '../lib/lib.videojs';

export default class VideoLazyLoad {
	constructor(video) {
		this.video = video;

		if(!window.IntersectionObserver) {
			this.enableSource();
		} else {
			this.setIntersectionListener();
		}
	}

	setIntersectionListener() {
		const observer = new IntersectionObserver(this.observeIntersection.bind(this), { root: null, rootMargin: '0px', threshold: 0.1 })
		observer.observe(this.video);
	}

	observeIntersection(entries, observer) {
		if(entries[0].isIntersecting) {
			this.enableSource();
			observer.disconnect();
		}
	}

	enableSource() {
		this.video.querySelector('source').setAttribute('src', this.video.querySelector('source').getAttribute('data-src'));
		new VideoJS([this.video]);
	}
}